import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import * as API from '../utils/api'
import axios from '../utils/axios'

const initalState = {
    status: 'idle',
    entity: null,
    error: null,
}

export const fetchSystem = createAsyncThunk(
    'system/fetchSystem', 
    async (data) => {
        console.log({data})
        const {buildingCode, systemCode} = data
        const url = API.SYSTEM_API.replace('{0}', buildingCode).replace('{1}', systemCode)
        return await axios.get(url)
                            .then(response => response.data)
    }
)

const systemSlice = createSlice({
    name: 'system',
    initialState: initalState,
    reducers:{

    },
    extraReducers:{
        [fetchSystem.pending]: (state, action) => {
            state.status = 'loading'
        },
        [fetchSystem.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            state.entity = action.payload
        },
        [fetchSystem.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
    }
})

export default systemSlice.reducer
